import { useMemo } from 'react';
import { Paper, List, ListItem, ListItemText, Typography, ListSubheader } from '@mui/material';
import { format } from 'date-fns';
import { CheckinSummary } from '@/types/api';
import { defaultCheckinDateFormat } from '@/utils/checkins';
import styles from './NextCheckinsList.styles';

export type NextCheckinsListType = {
  checkinsHistory: CheckinSummary[];
};

const NextCheckinsList = function ({ checkinsHistory }: NextCheckinsListType): JSX.Element {
  const listHeadlineText = useMemo(() => {
    return 'Check-in List';
  }, []);

  const renderNextCheckinsList = useMemo(() => {
    return checkinsHistory.filter(Boolean).map((checkin, index) => {
      return (
        <ListItem sx={index === 0 ? styles.selectedItem : {}} key={checkin.id}>
          <ListItemText
            primary={
              <>
                <Typography component="span" display="block" variant="body2" color="text.primary">
                  {checkin.userName}
                </Typography>

                {checkin?.dueDate && (
                  <Typography component="span" variant="body2" color="text.secondary">
                    {format(new Date(checkin?.dueDate), defaultCheckinDateFormat)}
                  </Typography>
                )}
              </>
            }
          />
        </ListItem>
      );
    });
  }, [checkinsHistory]);

  return (
    <Paper variant="outlined">
      <List
        subheader={
          <ListSubheader sx={styles.alignedCentered} component="h3">
            {listHeadlineText}
          </ListSubheader>
        }
        component="nav"
      >
        {renderNextCheckinsList}
      </List>
    </Paper>
  );
};

export default NextCheckinsList;
